import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client.safe';

export type UserRole = 'user' | 'moderator' | 'admin' | 'system_admin';

export const useUserRole = () => {
  const [role, setRole] = useState<UserRole | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        
        if (!user) {
          setRole(null);
          setLoading(false);
          return;
        }

        // Hämta användarens roll från databasen
        const { data: roleData, error: roleError } = await supabase
          .rpc('get_current_user_role');
        
        if (roleError) {
          console.error('Error fetching user role:', roleError);
          setRole('user'); // Fallback till user
        } else {
          setRole(roleData as UserRole || 'user');
        }
        
        setLoading(false);
      } catch (error) {
        console.error('Error in fetchUserRole:', error);
        setRole('user');
        setLoading(false);
      }
    };

    fetchUserRole();

    // Listen for auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange(() => {
      fetchUserRole();
    });

    return () => subscription.unsubscribe();
  }, []);

  return { role, loading };
};